import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  baseButton: {
    textTransform: 'initial',
    fontSize: Theme.typography.size[1],
    width: '100%',
    padding: '8px 20px',
    borderRadius: `${isCelebrity ? '1px' : '4px'}`,
    fontFamily: Theme.typography.base.semiBold,
    height: 40,

    '&.MuiButton-containedPrimary': {
      backgroundColor: `${isCelebrity ? Theme.palette.primary.main : Theme.palette.primary.light}`,
    },

    '&.Mui-disabled': {
      backgroundColor: `${Theme.palette.gray[500]}`,
      color: Theme.palette.white,
    },

    [Theme.breakpoints.up('sm')]: {
      width: 'auto',
      padding: '12px 32px',
    },
    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.size[3],
      height: 56,
    },

    '&.MuiButton-outlined': {
      border: `1px solid ${Theme.palette.secondary.main}`,
      color: Theme.palette.secondary.main,
    },
  },
}));

export default useStyles;
